import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=ddddf5a0&"
import script from "./AdminDashboard.vue?vue&type=script&lang=js&"
export * from "./AdminDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddddf5a0')) {
      api.createRecord('ddddf5a0', component.options)
    } else {
      api.reload('ddddf5a0', component.options)
    }
    module.hot.accept("./AdminDashboard.vue?vue&type=template&id=ddddf5a0&", function () {
      api.rerender('ddddf5a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/AdminDashboard.vue"
export default component.exports